import * as React from "react";
import { useMemo, useCallback } from "react";
import DetectionChainExpansion from "./DetectionChainExpansion";
const useTableComponents = () => {
  const renderExpansion = useCallback(
    (chain) => /* @__PURE__ */ React.createElement(DetectionChainExpansion, { name: chain.name }),
    []
  );
  const expandedSections = useMemo(
    () => ({
      detailsExpandedSection: {
        title: "Detection Chain",
        content: renderExpansion,
        disableHeader: true
      }
    }),
    [renderExpansion]
  );
  return { expandedSections };
};
export default useTableComponents;
